import React from 'react'

interface Props {}

function Load(props: Props) {
    const {} = props

    return (
        <div>...</div>
    )
}

export default Load
